import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const AddVehicleForm = lazyLoader(
  () => import("Components/Vehicles/AddVehicleForm")
);

export const AddVehicle: React.FC = () => {
  return (
    <Layout>
      <AddVehicleForm />
    </Layout>
  );
};
